// 메시지에 사진이 있을 경우 (상담사, 사용자)
const ChatMessageImg = ({ img, onClick, messageId, isUser }) => {
  return (
    <p className="py-2.5">
      <button
        onClick={() => onClick({ img, messageId, isUser })}
        className="transition-all hover:scale-95"
      >
        <img src={img} alt="" className="w-auto max-w-full" />
      </button>
    </p>
  );
};

export default ChatMessageImg;
